module.exports = __webpack_public_path__ + "media/images/favicon/secondary/favicon-32x32-b8d377f12f58fa1181d46ef076ae7e80.png";